
import ManagementMixin from '@/mixins/ManagementMixin';
import ProductListTable from '@/components/Management/Product/Table.vue';

export default {
  components: { ProductListTable },
  mixins: [ManagementMixin]
};
